export class HingeSideService {
    static readonly RIGHT_HINGE_ID = 1;
    static readonly LEFT_HINGE_ID = 2;
    static readonly BOTTOM_HINGE_ID = 3;

    constructor() {

    }
}